import {
    Container,
    Sprite,
} from 'pixi.js';
import { UIBoxBG } from './UIBoxBG';
import { Button, fonts, StyledBitmapText } from '../../ui';
import { CoordinateEntry } from './CoordinateEntry';
import { Grid } from './Grid';
import { GAMEPLAY } from '../../constants';
import { LoadContext } from '../../utils';

export class CoordinateMove extends Container
{
    private bg: UIBoxBG;
    private label: StyledBitmapText;
    public xCoord: CoordinateEntry;
    public yCoord: CoordinateEntry;
    private comma: Sprite;

    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('GameAtlas', './assets/game/GameAtlas{size}.json');

        UIBoxBG.preload();
        CoordinateEntry.preload();
        Button.preload();
    }

    constructor(grid: Grid)
    {
        super();

        const loader = LoadContext.current;

        this.bg = new UIBoxBG(296, 163);
        this.addChild(this.bg);

        this.label = new StyledBitmapText('Coordinates', fonts.GameLabel);
        this.label.anchor.set(0.5, 0.6);
        this.label.position.set(150, 36);
        this.addChild(this.label);

        this.xCoord = new CoordinateEntry(GAMEPLAY.X_LABELS.slice(0, grid.gridWidth));
        this.xCoord.position.set(94, 100);
        this.addChild(this.xCoord);

        this.yCoord = new CoordinateEntry(GAMEPLAY.Y_LABELS.slice(0, grid.gridHeight));
        this.yCoord.position.set(209, 100);
        this.addChild(this.yCoord);

        // comma between coordinate entries
        this.comma = new Sprite(loader.getSpritesheet('GameAtlas').textures['comma']);
        this.comma.position.set(145, 126);
        this.addChild(this.comma);

        this.xCoord.nextFocus = this.yCoord;
    }

    public get full()
    {
        return !!this.xCoord.coord && !!this.yCoord.coord;
    }

    public get partiallyFull()
    {
        return (!this.xCoord.coord && this.yCoord.coord) || (this.xCoord.coord && !this.yCoord.coord);
    }

    public get currentX()
    {
        return GAMEPLAY.X_LABELS.indexOf(this.xCoord.coord);
    }

    public get currentY()
    {
        return GAMEPLAY.Y_LABELS.indexOf(this.yCoord.coord);
    }

    public set enabled(enabled: boolean)
    {
        this.xCoord.enabled = enabled;
        this.yCoord.enabled = enabled;
    }

    public clear()
    {
        this.yCoord.clear();
        this.xCoord.clear();
    }

    public destroy()
    {
        super.destroy({children: true});
    }
}